export default __webpack_public_path__ + "static/media/fibre8.6f1bf84e.jpeg";